import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from 'actions/BaseAjaxConfig';
import { getObject, setObject } from 'utils/localStorage';
import { isValidPincode } from 'utils/validators';
import { get } from 'lodash';
export var PINCODE_REQUEST;
(function (PINCODE_REQUEST) {
    PINCODE_REQUEST["GET_PINCODE_REQUEST"] = "GET_PINCODE_REQUEST";
    PINCODE_REQUEST["GET_PINCODE_SUCCESS"] = "GET_PINCODE_SUCCESS";
    PINCODE_REQUEST["GET_PINCODE_ERROR"] = "GET_PINCODE_ERROR";
    PINCODE_REQUEST["GET_LOCAL_PINCODES"] = "GET_LOCAL_PINCODES";
    PINCODE_REQUEST["UPDATE_PINCODE"] = "UPDATE_PINCODE";
    PINCODE_REQUEST["FOCUS_PINCODE_INPUT"] = "FOCUS_PINCODE_INPUT";
    PINCODE_REQUEST["PINCODE_VALID"] = "PINCODE_VALID";
})(PINCODE_REQUEST || (PINCODE_REQUEST = {}));
// Need for SaleAction.tsx file
export function focusPincodeInputAction() {
    return { type: PINCODE_REQUEST.FOCUS_PINCODE_INPUT };
}
export function updatePincodeAction(pincode) {
    return {
        type: PINCODE_REQUEST.UPDATE_PINCODE,
        pincode
    };
}
function addPincodeToLocalStorage(item) {
    const localPincodes = getObject('pincodes') || [];
    const index = localPincodes.indexOf(item);
    if (index !== -1) {
        let newPincodes = [...localPincodes];
        newPincodes = [...newPincodes.slice(0, index), ...newPincodes.slice(index + 1), item];
        if (newPincodes && newPincodes.length > 3) {
            newPincodes.shift();
        }
        setObject('pincodes', newPincodes);
        return;
    }
    const newLocalPincodes = [...(localPincodes || []), item];
    if (newLocalPincodes && newLocalPincodes.length > 3) {
        newLocalPincodes.shift();
    }
    setObject('pincodes', newLocalPincodes);
}
export function fetchRecentPincodeAction() {
    return (dispatch, getState) => {
        const state = getState();
        dispatch({
            type: PINCODE_REQUEST.GET_LOCAL_PINCODES
        });
        const isLoggedIn = get(state, ['userState', 'isLoggedIn'], false);
        if (!isLoggedIn) {
            return null;
        }
        dispatch({
            type: PINCODE_REQUEST.GET_PINCODE_REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            headers,
            credentials: 'include',
            pathname: '/api/3/user/autosuggest/pincodes',
            action: PINCODE_REQUEST.GET_LOCAL_PINCODES,
            fk_api_timeout: __SERVER__ ? 4000 : baseAjaxConfig.fk_api_timeout
        })).then(json => dispatch({
            type: PINCODE_REQUEST.GET_PINCODE_SUCCESS,
            data: json['RESPONSE']
        }), error => {
            dispatch({ type: PINCODE_REQUEST.GET_PINCODE_ERROR, error });
        });
    };
}
export function validatePincodeAction(pincode, emptyAllowed = false) {
    return () => {
        if (emptyAllowed && pincode === '') {
            return Promise.resolve(true);
        }
        if (isValidPincode(pincode)) {
            return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
                headers,
                credentials: 'include',
                pathname: `/api/3/util/pincode/${pincode}`,
                action: PINCODE_REQUEST.PINCODE_VALID
            })).then(json => {
                const { valid } = json['RESPONSE'];
                valid && addPincodeToLocalStorage(pincode);
                return valid;
            }, error => Promise.reject(error));
        }
        return Promise.resolve(false);
    };
}
/**************************************/
// Pincode Details Request
/**************************************/
export var PINCODE_DETAIL;
(function (PINCODE_DETAIL) {
    PINCODE_DETAIL["REQUEST"] = "PINCODE_DETAIL_REQUEST";
    PINCODE_DETAIL["ERROR"] = "PINCODE_DETAIL_ERROR";
    PINCODE_DETAIL["SUCCESS"] = "PINCODE_DETAIL_SUCCESS";
})(PINCODE_DETAIL || (PINCODE_DETAIL = {}));
export function pincodeDetailAction(pincode, addressId) {
    return (dispatch) => {
        dispatch({
            type: PINCODE_DETAIL.REQUEST,
            addressId
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            headers,
            credentials: 'include',
            pathname: `/api/3/util/pincode/details/${pincode}`,
            action: PINCODE_DETAIL.REQUEST
        })).then(json => {
            const state = get(json, ['RESPONSE', 'state']);
            const city = get(json, ['RESPONSE', 'city']);
            return dispatch({
                type: PINCODE_DETAIL.SUCCESS,
                state,
                city,
                addressId
            });
        }, _ => {
            // TODO: this message should come from the backend.
            const error = {
                errorCode: 'pincode',
                errorMessage: 'Pincode is invalid'
            };
            return dispatch({
                type: PINCODE_DETAIL.ERROR,
                error,
                addressId
            });
        });
    };
}
export function fetchPincodeDetailsAction(pincode, addressId) {
    return (dispatch) => {
        dispatch({
            type: PINCODE_DETAIL.REQUEST,
            addressId
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            headers,
            credentials: 'include',
            pathname: `/api/1/address/pincode?pincode=${pincode}`,
            action: PINCODE_DETAIL.REQUEST
        })).then(json => {
            const response = get(json, ['RESPONSE', 'addressComponents', 0], {});
            const city = get(response, 'city') || get(response, 'district');
            const regionId = get(response, 'regionId');
            const regionType = get(response, 'regionType');
            const state = get(response, 'state');
            const regionTypeString = regionType ? regionType : regionId;
            return dispatch({
                type: PINCODE_DETAIL.SUCCESS,
                state,
                city,
                addressId,
                regionType: regionTypeString
            });
        }, _ => {
            // TODO: this message should come from the backend.
            const error = {
                errorCode: 'pincode',
                errorMessage: 'Pincode is invalid'
            };
            return dispatch({
                type: PINCODE_DETAIL.ERROR,
                error,
                addressId
            });
        });
    };
}
/**************************************/
// Pincode Serviceability Request
/**************************************/
export var PINCODE_SERVICEABILTY;
(function (PINCODE_SERVICEABILTY) {
    PINCODE_SERVICEABILTY["REQUEST"] = "PINCODE_SERVICEABILTY_REQUEST";
    PINCODE_SERVICEABILTY["ERROR"] = "PINCODE_SERVICEABILTY_ERROR";
    PINCODE_SERVICEABILTY["SUCCESS"] = "PINCODE_SERVICEABILTY_SUCCESS";
})(PINCODE_SERVICEABILTY || (PINCODE_SERVICEABILTY = {}));
export function fetchPincodeServiceability(pincode, marketplace) {
    return (dispatch) => {
        const pincodeServiceability = {
            locationContext: {
                pincode
            },
            marketplaceContext: {
                marketplace
            }
        };
        dispatch({
            type: PINCODE_SERVICEABILTY.REQUEST,
            pincodeServiceability,
            pincode
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers,
            credentials: 'include',
            acceptErrors: true,
            pathname: `/api/3/marketplace/serviceability`,
            action: PINCODE_SERVICEABILTY.REQUEST
        }), pincodeServiceability).then(json => {
            const marketplaceServiceability = get(json, ['RESPONSE']);
            if (marketplaceServiceability) {
                const { serviceability, pincode, message } = marketplaceServiceability;
                addPincodeToLocalStorage(pincode);
                return dispatch({
                    type: PINCODE_SERVICEABILTY.SUCCESS,
                    serviceability,
                    marketplace,
                    pincode,
                    message
                });
            }
        }, error => {
            const errorMessage = get(error, ['RESPONSE', 'errorMessage'], '');
            return dispatch({
                type: PINCODE_SERVICEABILTY.ERROR,
                errorMessage,
                pincode,
                marketplace
            });
        });
    };
}
